module.exports = __webpack_public_path__ + "root-b33b72b3/XING-Sans-Medium-3ac86813e0c602605662ca6330cb4f42.woff2";